(function () {
    function initConditionsSlider() {
      if (typeof $ === "undefined" || typeof $.fn.slick === "undefined") {
        setTimeout(initConditionsSlider, 100);
        return;
      }
  
      const slider = $("#conditions-slider");
      if (!slider.length) return;
  
      function isMobile() {
        return window.innerWidth <= 768;
      }
  
      function enableSlider() {
        if (!slider.hasClass("slick-initialized")) {
          slider.slick({
            slidesToShow: 1.20,
            slidesToScroll: 1,
            infinite: false,
            arrows: true,
            dots: false,
            speed: 400,
            swipe: true,
            touchMove: true,
            adaptiveHeight: true,
            prevArrow: `
              <button id="conditions-slider-prev-btn" class="conditions-section__nav-button conditions-section__nav-button--prev">
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20 5C11.7157 5 5 11.7157 5 20C5 28.2843 11.7157 35 20 35C28.2843 35 35 28.2843 35 20C35 11.7157 28.2843 5 20 5Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M22.5 26.25L16.25 20L22.5 13.75" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
              </button>`,
  
            nextArrow: `
              <button id="conditions-slider-next-btn" class="conditions-section__nav-button conditions-section__nav-button--next">
               <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_613_6444)">
<path d="M20 35C28.2843 35 35 28.2843 35 20C35 11.7157 28.2843 5 20 5C11.7157 5 5 11.7157 5 20C5 28.2843 11.7157 35 20 35Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M17.5 13.75L23.75 20L17.5 26.25" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_613_6444">
<rect width="40" height="40" fill="white"/>
</clipPath>
</defs>
</svg>
              </button>`
          });
        }
      }
  
      function disableSlider() {
        if (slider.hasClass("slick-initialized")) {
          slider.slick("unslick");
        }
      }
  
      if (isMobile()) enableSlider();
      else disableSlider();
  
      window.addEventListener("resize", () => {
        if (isMobile()) enableSlider();
        else disableSlider();
      });
    }
  
    document.addEventListener("DOMContentLoaded", initConditionsSlider);
  })();
  